import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import React from 'react';
import { InputContainer, Label, SelectContainer, SelectInner } from './styled';

interface SelectProps {
  className?: string;
  label?: string;
  children: React.ReactNode;
  selectRef?: any;
  [key: string]: any;
}

function Select({ className, label, children, selectRef, ...props }: SelectProps) {
  return (
    <InputContainer className={className}>
      <Label>{label}</Label>
      <SelectContainer>
        <IconWrapper size="30px">
          <Iconmoon className="icon-widget_alert" size="22px" />
        </IconWrapper>
        <SelectInner ref={selectRef} {...props}>
          {children}
        </SelectInner>
      </SelectContainer>
    </InputContainer>
  );
}

export default Select;
